import { GetGameById, UpdateAttendance } from "@grassrootly/api";
import useBaseRequest from "../../../api/BaseRequest";
import { useAlert, useAppDispatch } from "@grassrootly/rn-core";
import { gameActions } from "../../../api/game/GameReducer";
import { useUser } from "../../../api/auth/AuthSelector";

function useGetGame() {
  const dispatch = useAppDispatch();
  const { loading: gameFetching, execute: getGame } = useBaseRequest(GetGameById, {
    onCompleted: (data) => {
      if (!data) return;
      dispatch(gameActions.setGame(data));
    },
  });

  return { getGame, gameFetching };
}

export function useAcceptAttendece() {
  const { gameFetching, getGame } = useGetGame();
  const player = useUser();
  const { success } = useAlert();

  const accept = (gameId: number) => {
    execute({ id: gameId, attending: true, playerId: player?.id || 0 });
  };
  const { loading: accepting, execute } = useBaseRequest(UpdateAttendance, {
    onCompleted: (data) => {
      if (!data) return;
      getGame({ id: data.game_id });
      success({ title: "Congrants!", message: "You're in the line-up. See you at the game!" });
    },
  });

  return {
    accept,
    accepting: accepting || gameFetching,
  };
}

export function useDeclineAttendance() {
  const { gameFetching, getGame } = useGetGame();
  const player = useUser();

  const decline = (gameId: number) => {
    execute({ id: gameId, attending: false, playerId: player?.id || 0 });
  };
  const { loading: declining, execute } = useBaseRequest(UpdateAttendance, {
    onCompleted: (data) => {
      if (!data) return;
      getGame({ id: data.game_id });
    },
  });

  return {
    decline,
    declining: declining || gameFetching,
  };
}
